import LinkToDocusaurus from '../LinkToDocusaurus'
import { modelDashboard } from '../../docs-routes'

const LinkToQASummaryDoc = () =>
  <LinkToDocusaurus path={modelDashboard}>
    Learn more about Model Dashboard
  </LinkToDocusaurus>

export default LinkToQASummaryDoc
